/* Polyfills for IE */
import "../polyfill/assign";
import "../polyfill/ie-foreach";
import lozad from "lozad";
import ScrollTo from "../util/ScrollTo";
import MegaMenu from "../components/mega-menu";
import HierarchicalNav from "../components/hierarchical-nav";

export default {
    init() {

        // init lazy load plugin
        const observer = lozad('.lozad');
        observer.observe();

        // Initialize mega menu
        new MegaMenu();

        // Initialize hierarchical navigation
        new HierarchicalNav();

        $("#js-open-search, #js-search-close").click(function () {
            const modalInput = document.querySelector('#search-modal__input');
            document.body.classList.toggle('js-search-open');

            if (document.body.classList.contains('js-search-open') && modalInput) {
                modalInput.focus();
            }
        });

        /**
         * Enable collapse
         */
        $('.collapse').on('show.bs.collapse', function () {
            let $parent = $(this).closest('.accordion-content');
            $parent.addClass('collapsed');
        });

        $('.collapse').on('hide.bs.collapse', function () {
            let $parent = $(this).closest('.accordion-content');
            $parent.removeClass('collapsed');
        });

        /**
         * Site Alert Message
         */
        const siteAlert = document.querySelector(".header-alert")
        const closeAlert = document.querySelector(".close-header-alert")

        if (siteAlert) {
            if (localStorage.getItem("hideAlert")) {
                siteAlert.style.display = "none"
            } else{
                siteAlert.style.display = "block"
            }
        }

        if (closeAlert) {
            closeAlert.addEventListener("click", (event) => {
                event.preventDefault()
                siteAlert.classList.add("alert-hidden")
                localStorage.setItem("hideAlert", true)
            })
        }

        /**
         * Quick exit button logic
         */
        $(".quick-exit__button").click(function (e) {
            e.preventDefault();
            window.location.href = "https://www.bbc.co.uk/weather";
            window.open("https://www.google.co.uk");
        });


        /**
         * Initialise burger mobile navigation
         */
        $("#mobile-nav-button").click(function () {
            $('body').toggleClass('nav-is-open');
        });


        $(".smooth-scroll-to").each(function() {
            $(this).click(function() {
                let $element = $($(this).attr('href'));

                if($element) {
                    ScrollTo($element);
                }
            })
        });


        $(document).ready(() => {
            if('#myModal'.length) {
                if (window.localStorage.modal != "Modal displayed before") {
                    setTimeout(function () {
                        $("#myModal").modal('show');
                        window.localStorage.modal = "Modal displayed before";
                    }, 1);
                }
            }
        })


    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js